import {
  showMessage,
  executeProtocol,
  geVersion,
  redirectUrlByServer,
} from '_lib/utils';
import { getToolLinkID } from '_api/game.js';
import { palworld } from '_lib/bg-color.js';

//id: 获取link_id的唯一方式
export async function jumpPalDetailPage(url, id) {
  let redirectedURL = redirectUrlByServer(url, 'web');
  executeProtocol({
    protocol_type: 'showWaiting',
    show: '1', // 1是显示，0是隐藏
  });
  let openwindow_protocol = {
    protocol_type: 'openWindow',
    full_screen: true,
    status_bar: {
      style: 'light',
    },
    webview: {
      url: redirectedURL,
      bg: '014C6D',
      pull: false,
      refresh: false,
    },
    //bg_config: palworld,
    //transparent_bg: true,
  };
  if (geVersion('1.3.296')) {
    let link_id;
    try {
      let res = await getToolLinkID({
        unique_key: `palworld_${id}`,
      });
      if (res.data.status == 'ok') {
        link_id = res.data.result.linkid;
      } else {
        throw new Error('get link_id failed');
      }
      console.log('jumping router view', link_id);
      if (!link_id) {
        executeProtocol(openwindow_protocol);
        return;
      }
      redirectedURL = redirectUrlByServer(url + '&is_in_native=true', 'web');
      executeProtocol({
        path: '/web_with_native',
        params: {
          link_id: String(link_id),
          native_type: 'comment',
          url: redirectedURL,
          open_window_config: {
            show_loading: '1',
            status_bar: {
              style: 'light',
            },
            //"bg_config": palworld,
            bg_config: {
              bg_color: '#014C6D',
              pure_bg: 1,
            },
            navigation_bar: {
              title: '小黑盒 | 帕鲁图鉴',
            },
            full_screen: true,
          },
          recommend_info: {
            positive_info: {
              bg_check_color: '#D21F3C',
              bg_uncheck_color: '#4DD21F3C',
              text_uncheck_color: '#B2FFFFFF',
              text_check_color: '#FFFFFF',
              icon: 'https://imgheybox.max-c.com/oa/2023/12/06/0205b9d957245eaf5ced2468a54e3480.png',
              desc: '推荐',
            },
            negative_info: {
              bg_check_color: '#FF006EF4',
              bg_uncheck_color: '#1AFFFFFF',
              text_uncheck_color: '#B2FFFFFF',
              text_check_color: '#FFFFFF',
              icon: 'https://imgheybox.max-c.com/oa/2023/12/06/059a70e544f96744e942f9b8647c8484.png',
              desc: '不推荐',
            },
            comment_hint: '短评一下',
            commented_hint: '已经评论过',
          },
        },
        protocol_type: 'openRouterPath',
      });
    } catch (err) {
      executeProtocol(openwindow_protocol);
    }
  } else {
    executeProtocol(openwindow_protocol);
  }
  executeProtocol({
    protocol_type: 'showWaiting',
    show: '0', // 1是显示，0是隐藏
  });
}
export function canJumpNativeRouter() {
  return geVersion('1.3.296');
}
